module.exports = __webpack_public_path__ + "static/media/trash_can.cf080ef4.svg";